<template>
  <section class="content">
      <div class="error-page">
        <h2 class="headline text-warning"> 403</h2>

        <div class="error-content">
          <h3 class="text-warning">
            <i class="fas fa-exclamation-triangle text-warning"></i> Không có quyền truy cập
          </h3>

          <p>
            <router-link to="/admin/dashboard/" >Trở về trang chủ</router-link>.
          </p>

          <form class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" placeholder="Search">

              <div class="input-group-append">
                <button type="submit" name="submit" class="btn btn-warning"><i class="fas fa-search"></i>
                </button>
              </div>
            </div>
            <!-- /.input-group -->
          </form>
        </div>
        <!-- /.error-content -->
      </div>
      <!-- /.error-page -->
    </section>
</template>

<script>
export default {
    name: "TheNoPermission",
    data() {
        return {
          
        }
    }
}
</script>

<style>

</style>